import { configureStore } from '@reduxjs/toolkit';

// Initial state for the application
const initialState = {
  // Add your initial state here as needed
  ui: {
    loading: false,
    error: null,
  },
  user: {
    isAuthenticated: false,
    profile: null,
  },
};

// Root reducer - you can add more slices here as your app grows
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: action.payload,
        },
      };
    case 'SET_ERROR':
      return {
        ...state,
        ui: {
          ...state.ui,
          error: action.payload,
        },
      };
    case 'SET_USER':
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

// Configure the Redux store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Action creators
export const setLoading = (loading) => ({
  type: 'SET_LOADING',
  payload: loading,
});